export default __webpack_public_path__ + "static/media/logo-icon.fc995e09.svg";